import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    createCertificate,
    fetchAllCertificates,
    updateCertificate,
} from "../../../../store/slices/certificatesData";
import { setErrors } from "../../../../store/slices/certificatesForm";
import { createEducation } from "../../../../store/slices/educationLevelData";
import {
    createReference,
    fetchAllReferences,
    updateReference,
} from "../../../../store/slices/referencesData";
import { fetchAllCountries, fetchAllJobPositionLevels } from "../../../../store/slices/referencesForm";

const useForm = () => {
    const dispatch = useDispatch();

    const referencesForm = useSelector((state) => state.referencesForm);
    const referencesData = useSelector((state) => state.referencesData);

    useEffect(() => {
        dispatch(fetchAllReferences());
        dispatch(fetchAllJobPositionLevels());
        dispatch(fetchAllCountries());
    }, []);

    const handleSubmit = async () => {
        // try {
        //     await validationSchema.validate(
        //         {
        //             spec: educationLevelForm.spec,
        //             university: educationLevelForm.university,
        //             level: educationLevelForm.level,
        //             graduated: educationLevelForm.graduated,
        //             gradDate: educationLevelForm.gradDate,
        //         },
        //         { abortEarly: false }
        //     );
        // } catch (error) {
        //     const errors = collectAllValidationErrors(error);
        //     dispatch(setErrors(errors));
        //     window.scrollTo(0, 0);
        //     toast.warn("اصلح الحقول المطلوبة");
        //     return;
        // }

        const data = {
            name: referencesForm.name,
            relationship: referencesForm.relationship,
            jobPositionId: referencesForm.selectedJobPositionLevel.id,
            email: referencesForm.email,
            countryCode: "+" + referencesForm.selectedCountryCode.phoneCode,
            phoneNumber: referencesForm.phoneNumber,
        };

        if (referencesData.current) {
            dispatch(
                updateReference({
                    id: referencesData.current.id,
                    data,
                })
            );
        } else {
            dispatch(
                createReference({
                    data,
                })
            );
        }

        dispatch(setErrors(null));
        window.scrollTo(0, 0);
    };

    return [referencesForm, referencesData, handleSubmit];
};

export default useForm;
